import React from 'react';

const ContentDe = () => {
  return (
    <>
      <h2>Likiee GmbH Nutzungsbedingungen</h2>
      <p>
        Diese Nutzungsbedingungen regeln Ihre Nutzung der Website unter{' '}
        <a href='https://likiee.com'>https://likiee.com</a> und aller damit verbundenen Dienstleistungen, die von der
        Likiee GmbH angeboten werden.
      </p>
      <p>
        Durch den Zugriff auf <a href='https://likiee.com'>https://likiee.com</a> erklären Sie sich damit einverstanden,
        diese Nutzungsbedingungen einzuhalten und alle geltenden Gesetze und Vorschriften einzuhalten. Wenn Sie diesen
        Nutzungsbedingungen nicht zustimmen, ist Ihnen die Nutzung dieser Website oder aller anderen von der Likiee GmbH
        angebotenen Dienstleistungen untersagt.
      </p>
      <p>
        Wir, die Likiee GmbH, behalten uns das Recht vor, diese Nutzungsbedingungen nach eigenem Ermessen zu überprüfen
        und zu ändern. Wir werden diese Seite aktualisieren, wenn dies geschieht. Änderungen dieser Nutzungsbedingungen
        treten sofort ab dem Veröffentlichungsdatum in Kraft.
      </p>
      <p>Diese Nutzungsbedingungen wurden zuletzt am 17. November 2023 aktualisiert.</p>
      <h3>Einschränkungen der Nutzung</h3>
      <p>
        Bei der Nutzung dieser Website erklären Sie im Namen von sich selbst, Ihren Benutzern und anderen Parteien, die
        Sie vertreten, dass Sie nicht:
      </p>
      <ul>
        <li>
          Materialien und Software auf dieser Website ändern, kopieren, abgeleitete Werke erstellen, dekompilieren oder
          rückentwickeln;
        </li>
        <li>
          alle Urheberrechts- oder anderen Eigentumsvermerke von Materialien und Software auf dieser Website entfernen;
        </li>
        <li>
          die Materialien auf einen anderen Computer übertragen oder die Materialien auf einem anderen Server
          "spiegeln";
        </li>
        <li>
          wissentlich oder fahrlässig diese Website oder eine ihrer zugehörigen Dienstleistungen in einer Weise
          verwenden, die unsere Netzwerke oder einen anderen von der Likiee GmbH bereitgestellten Dienst missbraucht
          oder stört;
        </li>
        <li>
          diese Website oder ihre zugehörigen Dienstleistungen nutzen, um belästigendes, anstößiges, obszönes,
          betrügerisches oder gesetzwidriges Material zu übertragen oder zu veröffentlichen;
        </li>
        <li>
          diese Website oder ihre zugehörigen Dienstleistungen in Verletzung von geltenden Gesetzen oder Vorschriften
          verwenden;
        </li>
        <li>diese Website in Verbindung mit dem Versenden von nicht autorisierter Werbung oder Spam verwenden;</li>
        <li>Benutzerdaten ohne die Zustimmung des Benutzers sammeln, erfassen oder sammeln; oder</li>
        <li>
          diese Website oder ihre zugehörigen Dienstleistungen in einer Weise verwenden, die die Privatsphäre, geistigen
          Eigentumsrechte oder andere Rechte Dritter verletzen könnte.
        </li>
      </ul>
      <h3>Geistiges Eigentum</h3>
      <p>
        Das geistige Eigentum an den Materialien, die auf dieser Website enthalten sind, gehört der Likiee GmbH oder ist
        von ihr lizenziert und wird durch geltendes Urheber- und Markenrecht geschützt. Wir gewähren unseren Benutzern
        die Erlaubnis, eine Kopie der Materialien für den persönlichen, nicht kommerziellen vorübergehenden Gebrauch
        herunterzuladen.
      </p>
      <p>
        Dies stellt eine Lizenzgewährung dar, keine Übertragung des Titels. Diese Lizenz erlischt automatisch, wenn Sie
        eine dieser Beschränkungen oder die Nutzungsbedingungen verletzen, und kann von der Likiee GmbH jederzeit
        beendet werden.
      </p>
      <h3>Von Benutzern generierte Inhalte</h3>
      <p>
        Sie behalten Ihre geistigen Eigentumsrechte an Inhalten, die Sie uns zur Veröffentlichung auf unserer Website
        übermitteln. Wir werden niemals Eigentumsansprüche an Ihren Inhalten erheben, benötigen jedoch eine Lizenz von
        Ihnen, um diese verwenden zu können.
      </p>
      <p>
        Wenn Sie unsere Website oder ihre zugehörigen Dienstleistungen verwenden, um Inhalte, die durch geistige
        Eigentumsrechte geschützt sind, zu veröffentlichen, hochzuladen, zu teilen oder anderweitig zu übertragen,
        gewähren Sie uns eine nicht exklusive, lizenzgebührenfreie, übertragbare, unterlizenzierbare, weltweite Lizenz
        zur Verwendung, Verteilung, Änderung, Ausführung, Kopie, öffentlichen Anzeige, Übersetzung oder Erstellung
        abgeleiteter Werke Ihrer Inhalte in einer Weise, die mit Ihren Datenschutzpräferenzen und unserer
        Datenschutzrichtlinie in Einklang steht.
      </p>
      <p>
        Die von Ihnen gewährte Lizenz kann jederzeit durch das Löschen Ihrer Inhalte oder Ihres Kontos beendet werden.
        Soweit wir (oder unsere Partner) jedoch Ihre Inhalte im Zusammenhang mit kommerziellen oder gesponserten
        Inhalten verwendet haben, wird die Lizenz fortgesetzt, bis der entsprechende kommerzielle oder Beitrag von uns
        eingestellt wurde.
      </p>
      <p>
        Sie geben uns die Erlaubnis, Ihren Benutzernamen und andere Identifikationsinformationen, die mit Ihrem Konto
        verbunden sind, in einer Weise zu verwenden, die mit Ihren Datenschutzpräferenzen und unserer
        Datenschutzrichtlinie in Einklang steht.
      </p>
      <h3>Haftung</h3>
      <p>
        Unsere Website und die Materialien auf unserer Website werden "wie besehen" zur Verfügung gestellt. Soweit
        gesetzlich zulässig, übernehmen die Likiee GmbH keine Garantien, ausdrücklich oder stillschweigend, und lehnen
        hiermit alle anderen Garantien ab, einschließlich, aber nicht beschränkt auf stillschweigende Garantien oder
        Bedingungen der Marktgängigkeit, Eignung für einen bestimmten Zweck oder Nichtverletzung geistigen Eigentums
        oder sonstiger Rechte.
      </p>
      <p>
        In keinem Fall haften die Likiee GmbH oder ihre Lieferanten für Verluste, die von Ihnen oder einer dritten
        Partei aufgrund der Nutzung oder Unmöglichkeit der Nutzung dieser Website oder der Materialien auf dieser
        Website entstehen, selbst wenn die Likiee GmbH oder ein autorisierter Vertreter von der Möglichkeit eines
        solchen Schadens in Kenntnis gesetzt wurde, sei es mündlich oder schriftlich.
      </p>
      <p>
        Im Rahmen dieser Vereinbarung umfasst der Begriff "Folgeschaden" jeden Folgeschaden, indirekten Schaden, realen
        oder erwarteten Gewinnverlust, Nutzenverlust, Umsatzverlust, Geschäftsverlust, Goodwill-Verlust, Verlust von
        Gelegenheiten, Einsparungsverlust, Rufverlust, Nutzungsentzug und/oder Verlust oder Beschädigung von Daten,
        unabhängig davon, ob dies gesetzlich, vertraglich, nach Treu und Glauben, aus unerlaubter Handlung
        (einschließlich Fahrlässigkeit), durch Gewährleistung oder auf andere Weise erfolgt.
      </p>
      <p>
        Weil einige Gerichtsbarkeiten keine Beschränkungen für stillschweigende Garantien oder Haftungsbeschränkungen
        für Folge- oder Nebenschäden zulassen, gelten diese Beschränkungen möglicherweise nicht für Sie.
      </p>
      <h3>Richtigkeit der Materialien</h3>
      <p>
        Die auf unserer Website angezeigten Materialien sind nicht umfassend und dienen nur allgemeinen
        Informationszwecken. Die Likiee GmbH übernimmt keine Gewähr oder macht keine Zusicherungen hinsichtlich der
        Genauigkeit, wahrscheinlichen Ergebnisse oder Zuverlässigkeit der Verwendung der Materialien auf dieser Website
        oder anderweitig in Bezug auf solche Materialien oder auf Ressourcen, die mit dieser Website verlinkt sind.
      </p>
      <h3>Links</h3>
      <p>
        Die Likiee GmbH hat nicht alle auf ihrer Website verlinkten Websites überprüft und ist nicht für den Inhalt
        einer solchen verlinkten Website verantwortlich. Die Aufnahme eines Links bedeutet keine Billigung, Genehmigung
        oder Kontrolle durch die Likiee GmbH der Website. Die Nutzung einer solchen verlinkten Website erfolgt auf
        eigenes Risiko, und wir empfehlen dringend, eigene Untersuchungen zur Eignung dieser Websites anzustellen.
      </p>
      <h3>Recht zur Kündigung</h3>
      <p>
        Wir können Ihr Recht zur Nutzung unserer Website vorübergehend aussetzen oder beenden und diese
        Nutzungsbedingungen sofort schriftlich kündigen, wenn Sie gegen diese Nutzungsbedingungen verstoßen.
      </p>
      <h3>Salvatorische Klausel</h3>
      <p>
        Jede Bestimmung dieser Nutzungsbedingungen, die ganz oder teilweise nichtig oder nicht durchsetzbar ist, wird in
        dem Umfang aufgehoben, in dem sie nichtig oder nicht durchsetzbar ist. Die Gültigkeit des Rests dieser
        Nutzungsbedingungen bleibt unberührt.
      </p>
      <h3>Anwendbares Recht</h3>
      <p>
        Diese Nutzungsbedingungen unterliegen den Gesetzen von Deutschland und werden entsprechend ausgelegt. Sie
        unterwerfen sich unwiderruflich der ausschließlichen Gerichtsbarkeit der Gerichte in diesem Staat oder Ort.
      </p>
    </>
  );
};

export default ContentDe;
